import * as tslib_1 from "tslib";
// Core packages
import { EventEmitter, OnChanges, OnInit, SimpleChanges } from "@angular/core";
// Third party packages
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
// Custom packages
var FileUploaderComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function FileUploaderComponent(toastrService, translateService) {
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.files = [];
        this.hasFile = false;
        this.uploadFiles = new EventEmitter(); // Callback used to actually upload files to the back-end
    }
    /**
     * Init component
     */
    FileUploaderComponent.prototype.ngOnInit = function () {
        this.allowedExtensionsArray = this.allowedFilesExt
            ? this.allowedFilesExt.toLowerCase().split(",")
            : ['*'];
        this.allowedFilesExtWithDot = "." + this.allowedExtensionsArray.join(",.");
    };
    /**
     * Listen for @Input changes and trigger the uploadFile @Output
     *
     * @since 1.0.0
     */
    FileUploaderComponent.prototype.ngOnChanges = function (changes) {
        if (changes.upload && typeof changes.upload.previousValue !== "undefined") {
            this.onUploadFiles();
        }
        if (changes.fileReset &&
            typeof changes.fileReset.previousValue !== "undefined") {
            this.files = [];
            this.hasFile = false;
        }
    };
    /**
     * Emit a new value for the uploadFiles @Output with
     * a list of loaded files
     *
     * @since 1.0.0
     */
    FileUploaderComponent.prototype.onUploadFiles = function () {
        var maxNumber = this.allowedFilesNumber ? this.allowedFilesNumber : 1;
        if (!this.files.length) {
            return;
        }
        if (!this.allowedMBNumber) {
            if (this.files.length > maxNumber) {
                // @todo translate
                this.toastrService.error("Puoi caricare massimo " + maxNumber + " file alla volta");
                this.files = [];
                return;
            }
        }
        else {
            var megaByte = this.files.reduce(function (prev, item) { return prev + item.size; }, 0) / 1024 / 1024;
            if (megaByte > this.allowedMBNumber) {
                // @todo translate
                this.toastrService.error("Puoi caricare massimo " + this.allowedMBNumber + " MB");
                this.files = [];
                return;
            }
            if (this.files.length > maxNumber) {
                // @todo translate
                this.toastrService.error("Puoi caricare massimo " + maxNumber + " file alla volta");
                this.files = [];
                return;
            }
        }
        this.uploadFiles.emit(this.files);
    };
    /**
     * Handle dropped file once they are released on the dropzone area
     *
     * @since 1.0.0
     *
     * @param files uploaded files
     */
    FileUploaderComponent.prototype.dropped = function (files) {
        var e_1, _a;
        var _this = this;
        var maxNumber = this.allowedFilesNumber ? this.allowedFilesNumber : 1;
        var toastrServiceReplica = this.toastrService;
        var _loop_1 = function (droppedFile) {
            // Is it a file
            if (droppedFile.fileEntry.isFile) {
                var fileEntry = droppedFile.fileEntry;
                fileEntry.file(function (file) {
                    // Check if file type is allowed here
                    var fileName = file.name;
                    var extension = fileName.split(".").pop().toLowerCase();
                    if (_this.allowedExtensionsArray.includes(extension) || _this.allowedExtensionsArray.includes('*')) {
                        var newFile = tslib_1.__assign({}, droppedFile, { size: file.size, type: file.type.replace("/", "-") });
                        _this.files.push(newFile); // Push file
                        _this.hasFile = true; // Inform component that there is at least one file
                    }
                    else {
                        toastrServiceReplica.error(_this.translateService.instant("common.fileUploader.wrongFileFormat", { fileName: droppedFile.relativePath }));
                    }
                });
            }
            else {
                // It was a directory (empty directories are added, otherwise only files)
                // const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
                alert(this_1.translateService.instant("common.fileUploader.folderNotAccepted"));
            }
        };
        var this_1 = this;
        try {
            for (var files_1 = tslib_1.__values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                var droppedFile = files_1_1.value;
                _loop_1(droppedFile);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Automatically upload on file choose.
        // Wait 500ms in order to get files pushing finished
        setTimeout(function () {
            _this.onUploadFiles();
        }, 500);
    };
    /**
     * Transform given size in bytes to
     * a kb string
     *
     * @since 1.0.0
     *
     * @param size The size to transform
     * @return Transformed size string with 2 decimals
     */
    FileUploaderComponent.prototype.getFormattedSize = function (size) {
        var sizeInKb = size / 1024;
        return sizeInKb.toFixed(2);
    };
    /**
     * Remove file with given index from upload files list
     *
     * @since 1.0.0
     *
     * @param index The index of the file to remove
     * @retuens undefined
     */
    FileUploaderComponent.prototype.onFileRemove = function (index) {
        this.files.splice(index, 1);
        if (this.files.length === 0) {
            this.hasFile = false;
        }
    };
    FileUploaderComponent.prototype.fileOver = function (event) {
    };
    FileUploaderComponent.prototype.fileLeave = function (event) {
    };
    return FileUploaderComponent;
}());
export { FileUploaderComponent };
